var _style, _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDesenvolvimentoSoftware(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "desenvolvimento-software",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 171 171",
    style: {
      enableBackground: "new 0 0 171 171"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#DD5100;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "desenvolvimento-software_1_"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M128,111.5H31.4V40.7H128v7.7h8.2V32.5h-113v87.1h38.6c0,0.5-0.1,1-0.2,1.4c-0.5,3.4-1.5,6.1-3,7.6 c-1.1,1.2-2.5,1.7-4.4,1.7h-1.3v8.2h50.3v-8.2h-1.3c-1.4,0-2.4-0.4-3.2-1.3c-1.6-1.7-2.8-5.2-3.1-9.5H136V85.6h-8V111.5z  M67.3,130.5c1.8-3.5,2.5-7.6,2.7-10.8h17.5c0.1,0.9,0.2,1.8,0.3,2.7c0.4,3.1,1.2,5.8,2.3,8.1H67.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M80.8,90.9l-4.9,4.9c-3.2-0.4-5.9,2.2-5.9,5.3c0,3,2.4,5.4,5.4,5.4s5.4-2.4,5.4-5.4c0-0.2,0-0.4,0-0.6 l4.9-4.9L80.8,90.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M147.8,71.1v-8.2H143c-0.1-0.2-0.2-0.5-0.3-0.7l3.5-3.5l-5.8-5.8l-3.5,3.5c-0.2-0.1-0.5-0.2-0.7-0.3v-4.9H128 v4.9c-0.2,0.1-0.4,0.2-0.6,0.2l-3.5-3.5l-5.8,5.8l3.5,3.5c-0.1,0.2-0.2,0.5-0.3,0.7h-5V71h5c0.1,0.2,0.2,0.5,0.3,0.7l-3.5,3.5 l5.8,5.8l3.5-3.5c0.2,0.1,0.4,0.2,0.6,0.2v4.9h8.2v-4.9c0.2-0.1,0.5-0.2,0.7-0.3l3.5,3.5l5.8-5.8l-3.5-3.5 c0.1-0.2,0.2-0.5,0.3-0.7h4.8V71.1z M136.1,67.4c-0.2,2-1.9,3.7-4,3.7c-1.1,0-2.1-0.4-2.8-1.1c-0.8-0.8-1.2-1.8-1.2-2.9 c0-2.3,1.7-4,3.9-4c1.1,0,2.2,0.5,3,1.3C135.9,65.1,136.2,66.2,136.1,67.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M115,55.5l-1-4.7l-2.9,0.6c-0.1-0.2-0.3-0.4-0.4-0.6l1.6-2.5l-4-2.6l-1.6,2.5c-0.2,0-0.4-0.1-0.6-0.1 l-0.6-2.9l-4.7,1l0.6,2.9c-0.2,0.1-0.4,0.2-0.6,0.4l-2.6-1.6l-2.6,4l2.6,1.6c-0.1,0.2-0.1,0.4-0.1,0.7l-2.9,0.6l1,4.7l2.9-0.6 c0.1,0.2,0.2,0.3,0.3,0.5l-1.6,2.5l4,2.6l1.6-2.5c0.2,0.1,0.4,0.1,0.7,0.1l0.6,2.9l4.7-1l-0.6-2.9c0.2-0.1,0.4-0.2,0.6-0.4 l2.5,1.6l2.6-4l-2.5-1.6c0.1-0.2,0.1-0.4,0.1-0.7L115,55.5z M107.1,56.9c-0.8,1.1-2.3,1.3-3.5,0.6c-0.6-0.4-1-0.9-1.1-1.6 c-0.2-0.7,0-1.4,0.4-2c0.5-0.8,1.3-1.2,2.2-1.2c0.5,0,0.9,0.1,1.4,0.4c0.6,0.4,1,1,1.2,1.8C107.7,55.6,107.6,56.3,107.1,56.9z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 40.1,
    y: 45.9,
    className: "st0",
    width: 34.6,
    height: 4.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 40.1,
    y: 53.3,
    className: "st0",
    width: 25.8,
    height: 4.8
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M112.2,105v-3.6c0-8.6-3-16.9-8.6-23.4l0.1-0.1l-4.2-4.1l-1-0.9L98.4,73c-5.4-4.4-12-7.1-19-7.7v-0.2h-5.8 l-1.3,0.1v0.1c-7.1,0.7-13.7,3.4-19.2,7.8L53,73l-4.1,4.1l-0.9,1l0.1,0.1c-5.5,6.5-8.5,14.8-8.5,23.4v3.6h18v-3.6 c0-5,2-9.7,5.6-13.2c3.4-3.3,8-5.2,12.7-5.2s9.2,1.8,12.7,5.1c3.6,3.5,5.6,8.3,5.6,13.3v3.6h18V105z M101,97.9 c-0.6-4.4-2.4-8.6-5.2-12.1l2.7-2.7c3.4,4.3,5.6,9.4,6.3,14.8C104.8,97.9,101,97.9,101,97.9z M93.4,78.1l-2.7,2.7 c-3.4-2.4-7.2-4-11.3-4.6v-3.8C84.5,73.1,89.3,75,93.4,78.1z M46.8,97.9c0.7-5.4,2.8-10.5,6.2-14.7l2.7,2.7 c-2.7,3.5-4.5,7.6-5.1,12.1L46.8,97.9L46.8,97.9z M72.3,72.4v3.8c-4.1,0.6-8.1,2.2-11.4,4.6l-2.7-2.7C62.3,75,67.1,73.1,72.3,72.4 z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDesenvolvimentoSoftware);
export default __webpack_public_path__ + "static/media/desenvolvimento-software.ce14d6b56f9623e6c70b7e7ceecba88a.svg";
export { ForwardRef as ReactComponent };